// import { Box, Card, CardContent, Grid, IconButton, Typography, LinearProgress } from "@mui/material";
// import React, { Fragment, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useTimeSheet } from "../../Config/TimeSheetContext";
// import APILIST from "../../Config/ApiList";
// import AxiosInstance from "../../Config/AxiosInstance";
// import 'react-loading-skeleton/dist/skeleton.css'
// import Ranking from "../../Utils/Ranking.json";
// import Lottie from "lottie-react";
// import { Circles } from "react-loader-spinner";

// const BadgeBoard = () => {
//     const navigate = useNavigate();
//     const { timeSheetUserDetails, isLoading } = useTimeSheet();
//     const [isLead, setIsLoad] = useState(true);
//     const [badgeBoardList, setBadgeBoardList] = useState([]);
//     const [userBadgeData, setUserBadgeData] = useState(null);
//     const [userDetails, setUserDetails] = useState(null);

//     useEffect(() => {
//         if (timeSheetUserDetails?.Company_details[0]?.id) {
//             getBadgeLeaderBoard(timeSheetUserDetails?.Company_details[0]?.id);
//             getUserBadgeData(timeSheetUserDetails?.Company_details[0]?.id);
//         }
//     }, [timeSheetUserDetails?.Company_details[0]?.id]);

//     const getBadgeLeaderBoard = async (id) => {
//         setIsLoad(true);
//         try {
//             const response = await AxiosInstance.get(APILIST.GET_BADGE_LEADER_BOARD, {
//                 params: { company_id: id }
//             });
//             if (response?.data?.s) {
//                 setBadgeBoardList(response.data.r);
//             }
//         } catch (error) {
//             console.error('Error fetching badge leaderboard:', error);
//         } finally {
//             setIsLoad(false);
//         }
//     };

//     const getUserBadgeData = async (id) => {
//         try {
//             const response = await AxiosInstance.post(APILIST.GET_USER, {
//                 params: { company_id: id }
//             });
//             if (response?.data?.s) {
//                 setUserDetails(response.data.r.user_details);
//                 setUserBadgeData(response.data.r);
//             }
//         } catch (error) {
//             console.error('Error fetching user badge data:', error);
//         }
//     };
//     const calculateProgress = () => {
//         if (!userBadgeData || !badgeBoardList.length) return { progress: 0, nextBadge: null };

//         const currentLeads = userBadgeData.lead_count || 0;
//         const sortedBadges = [...badgeBoardList].sort((a, b) => a.lead_count - b.lead_count);
//         const nextBadge = sortedBadges.find(badge => badge.lead_count > currentLeads);

//         if (!nextBadge) return { progress: 100, nextBadge: null };

//         const progress = (currentLeads / nextBadge.lead_count) * 100;
//         return { progress, nextBadge };
//     };

//     const { progress, nextBadge } = calculateProgress();
//     const leadsNeeded = nextBadge ? nextBadge.lead_count - (userBadgeData?.lead_count || 0) : 0;
//     const currentBadge = userBadgeData?.badge?.title || "No Badge Yet";
//     return (
//         <Fragment>
//         {/* Fullscreen loading overlay */}
//         {(isLoading || isLead) && (
//           <Box
//             sx={{
//               position: "fixed",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "100vh",
//               backgroundColor: "rgba(0, 0, 0, 0.7)",
//               zIndex: 9999,
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             {isLoading ? (
//               <Lottie animationData={Ranking} loop={true} />
//             ) : (
//               <Circles height="80" width="80" color="#4fa94d" />
//             )}
//           </Box>
//         )}
  
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             width: "100%",
//             minHeight: "100vh",
//             background: "rgba(13, 18, 41, 1)",
//             overflowY: "auto", // ✅ enable mobile scroll
//           }}
//         >
//           {/* Header */}
//           <Box
//             sx={{
//               background: "rgba(37, 42, 62, 1)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               position: "fixed",
//               top: "0px",
//               left: "0px",
//               right: "0px",
//               padding: "10px 15px",
//               zIndex: 10,
//               width: "100%",
//             }}
//           >
//             <Box sx={{ width: "10%" }}>
//               <IconButton
//                 sx={{
//                   width: "42px",
//                   height: "42px",
//                   borderRadius: "50%",
//                   background: "rgba(59, 63, 81, 1)",
//                 }}
//                 onClick={() => navigate(-1)}
//               >
//                 <img
//                   src="/back-arrow.webp"
//                   alt="back-arrow"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//               </IconButton>
//             </Box>
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 width: "auto",
//                 flex: 1,
//               }}
//             >
//               <Typography
//                 variant="h6"
//                 sx={{
//                   color: "#ffffff",
//                   fontSize: "20px",
//                   fontWeight: "600",
//                   fontFamily: "Poppins",
//                   textAlign: "center",
//                   width: "100%",
//                 }}
//               >
//                 Badge Board
//               </Typography>
//             </Box>
//             <Box sx={{ width: "10%" }}></Box>
//           </Box>
  
//           {/* Content */}
//           <Box
//             sx={{
//               width: "100%",
//               padding: "100px 15px 15px 15px",
//               boxSizing: "border-box",
//             }}
//           >
//             {/* User Badge Card */}
//             <Card
//               sx={{
//                 background: "rgba(37, 42, 62, 0.8)",
//                 borderRadius: "12px",
//                 marginBottom: "20px",
//                 boxShadow: "none",
//                 border: "1px solid rgba(59, 63, 81, 1)",
//               }}
//             >
//               <CardContent sx={{ padding: { xs: "16px", sm: "20px" } }}>
//                 <Typography
//                   variant="h5"
//                   sx={{
//                     fontWeight: 600,
//                     marginBottom: "16px",
//                     textAlign: "center",
//                     color: "#ffffff",
//                   }}
//                 >
//                   {userDetails?.f_name} {userDetails?.l_name}
//                 </Typography>
  
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: { xs: "column", sm: "row" },
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     gap: "16px",
//                     marginBottom: "16px",
//                   }}
//                 >
//                   <Box sx={{ textAlign: "center", flex: 1 }}>
//                     <Typography variant="body2" sx={{ color: "#fff" }}>
//                       Total Verified Leads:
//                     </Typography>
//                     <Typography variant="h6" sx={{ color: "#fff" }}>
//                       {userBadgeData?.lead_count || 0}
//                     </Typography>
//                   </Box>
  
//                   <Box sx={{ order: { xs: -1, sm: 0 }, textAlign: "center", flex: 1 }}>
//                     <Typography variant="body2" sx={{ color: "#fff" }}>
//                       Badge:
//                     </Typography>
//                     <Typography
//                       variant="h6"
//                       sx={{ color: "#4fa94d", fontSize: "3rem", lineHeight: 1 }}
//                     >
//                       {userBadgeData?.badge?.badge || 0}
//                     </Typography>
//                   </Box>
  
                
//                 </Box>
  
//                 <Box
//                   sx={{
//                     height: "1px",
//                     background: "rgba(59, 63, 81, 1)",
//                     margin: "16px 0",
//                   }}
//                 />
  
//                 <Box sx={{ textAlign: "center" }}>
//                   <Typography variant="h6" sx={{ color: "#4fa94d", marginBottom: "8px" }}>
//                     {currentBadge}
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     sx={{ color: "rgba(255,255,255,0.7)", marginBottom: "4px" }}
//                   >
//                     Progress to next badge:
//                   </Typography>
//                   <Typography variant="body1" sx={{ color: "#ffffff", marginBottom: "8px" }}>
//                     {userBadgeData?.lead_count || 0}/{nextBadge?.lead_count || "20"}
//                   </Typography>
//                   <LinearProgress
//                     variant="determinate"
//                     value={progress}
//                     sx={{
//                       height: "8px",
//                       borderRadius: "4px",
//                       marginBottom: "12px",
//                       backgroundColor: "rgba(59, 63, 81, 1)",
//                       "& .MuiLinearProgress-bar": {
//                         backgroundColor: "#4fa94d",
//                       },
//                     }}
//                   />
//                   <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)" }}>
//                     {leadsNeeded > 0
//                       ? `${leadsNeeded} more leads needed for ${nextBadge?.title || "next"} badge`
//                       : "You've reached the highest badge!"}
//                   </Typography>
//                 </Box>
//               </CardContent>
//             </Card>
  
//             {/* Badges List */}
//             <Typography
//               variant="h6"
//               sx={{
//                 color: "#ffffff",
//                 fontSize: "18px",
//                 fontWeight: "600",
//                 fontFamily: "Poppins",
//                 marginBottom: "20px",
//               }}
//             >
//               Available Badges
//             </Typography>
//             <Grid container spacing={3}>
//               {badgeBoardList?.map((badge) => (
//                 <Grid item xs={12} sm={6} md={4} key={badge.id}>
//                   <Card
//                     sx={{
//                       background: "rgba(37, 42, 62, 1)",
//                       borderRadius: "12px",
//                       padding: "20px",
//                       textAlign: "center",
//                       border: "1px solid rgba(59, 63, 81, 1)",
//                     }}
//                   >
//                     <Typography variant="h2" sx={{ fontSize: "48px", marginBottom: "10px" }}>
//                       {badge.badge}
//                     </Typography>
//                     <CardContent>
//                       <Typography
//                         variant="h5"
//                         sx={{
//                           color: "#ffffff",
//                           fontSize: "18px",
//                           fontWeight: "600",
//                           marginBottom: "8px",
//                         }}
//                       >
//                         {badge.title}
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "14px", whiteSpace: "pre-line" }}
//                       >
//                         {badge.subtitle}
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           color: "rgba(255, 255, 255, 0.5)",
//                           fontSize: "12px",
//                           marginTop: "10px",
//                         }}
//                       >
//                         {badge.lead_count} {badge.lead_count === 1 ? "lead" : "leads"} required
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           </Box>
//         </Box>
//       </Fragment> 
//     )
// };

// export default BadgeBoard;
import { Box, Card, IconButton, List, ListItem, Typography, LinearProgress, Avatar } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTimeSheet } from "../../Config/TimeSheetContext";
import APILIST from "../../Config/ApiList";
import AxiosInstance from "../../Config/AxiosInstance";
import { Circles } from "react-loader-spinner";
import Lottie from "lottie-react";
import Ranking from "../../Utils/Ranking.json";

const BadgeBoard = () => {
    const navigate = useNavigate();
    const { timeSheetUserDetails, isLoading } = useTimeSheet();
    const [isLead, setIsLoad] = useState(true);
    const [badgeBoardList, setBadgeBoardList] = useState([]);
    const [userBadgeData, setUserBadgeData] = useState(null);
    const [userDetails, setUserDetails] = useState(null);

    useEffect(() => {
        if (timeSheetUserDetails?.Company_details[0]?.id) {
            getBadgeLeaderBoard(timeSheetUserDetails?.Company_details[0]?.id);
            getUserBadgeData(timeSheetUserDetails?.Company_details[0]?.id);
        }
    }, [timeSheetUserDetails?.Company_details[0]?.id]);

    const getBadgeLeaderBoard = async (id) => {
        setIsLoad(true);
        try {
            const response = await AxiosInstance.get(APILIST.GET_BADGE_LEADER_BOARD, {
                params: { company_id: id }
            });
            if (response?.data?.s) {
                setBadgeBoardList(response.data.r);
            }
        } catch (error) {
            console.error('Error fetching badge leaderboard:', error);
        } finally {
            setIsLoad(false);
        }
    };

    const getUserBadgeData = async (id) => {
        try {
            const response = await AxiosInstance.post(APILIST.GET_USER, {
                params: { company_id: id }
            });
            if (response?.data?.s) {
                setUserDetails(response.data.r.user_details);
                setUserBadgeData(response.data.r);
            }
        } catch (error) {
            console.error('Error fetching user badge data:', error);
        }
    };

    const calculateProgress = () => {
        if (!userBadgeData || !badgeBoardList.length) return { progress: 0, nextBadge: null };

        const currentLeads = userBadgeData.lead_count || 0;
        const sortedBadges = [...badgeBoardList].sort((a, b) => a.lead_count - b.lead_count);
        const nextBadge = sortedBadges.find(badge => badge.lead_count > currentLeads);

        if (!nextBadge) return { progress: 100, nextBadge: null };

        const progress = (currentLeads / nextBadge.lead_count) * 100;
        return { progress, nextBadge };
    };

    const { progress, nextBadge } = calculateProgress();
    const leadsNeeded = nextBadge ? nextBadge.lead_count - (userBadgeData?.lead_count || 0) : 0;
    const currentBadge = userBadgeData?.badge?.title || "No Badge Yet";

    return (
        <Fragment>
            {(isLoading || isLead) && (
                <Box
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        zIndex: 9999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {isLoading ? (
                        <Lottie animationData={Ranking} loop={true} />
                    ) : (
                        <Circles height="80" width="80" color="#4fa94d" />
                    )}
                </Box>
            )}

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                    height: "100vh",
                    background: "rgba(13, 18, 41, 1)",
                    overflow: "hidden",
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        background: "rgba(37, 42, 62, 1)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "12px 16px",
                        width: "100%",
                    }}
                >
                    <IconButton
                        sx={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            background: "rgba(59, 63, 81, 1)",
                        }}
                        onClick={() => navigate(-1)}
                    >
                        <img
                            src="/back-arrow.webp"
                            alt="back-arrow"
                            style={{ width: "16px", height: "16px" }}
                        />
                    </IconButton>
                    <Typography
                        variant="h6"
                        sx={{
                            color: "#ffffff",
                            fontSize: "18px",
                            fontWeight: "600",
                            fontFamily: "Poppins",
                        }}
                    >
                        Badge Board
                    </Typography>
                    <Box sx={{ width: "36px" }} /> {/* Spacer for alignment */}
                </Box>

                {/* Compact User Info */}
                <Box
                    sx={{
                        width: "100%",
                        padding: "16px",
                        background: "rgba(37, 42, 62, 0.5)",
                        borderBottom: "1px solid rgba(59, 63, 81, 1)",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: "12px", mb: 1 }}>
                        <Avatar sx={{ bgcolor: "#4fa94d", width: 40, height: 40 }}>
                            {userDetails?.f_name?.[0]}{userDetails?.l_name?.[0]}
                        </Avatar>
                        <Box>
                            <Typography variant="subtitle1" sx={{ color: "#fff" }}>
                                {userDetails?.f_name} {userDetails?.l_name}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)" }}>
                                {userBadgeData?.lead_count || 0} verified leads
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ mt: 1 }}>
                        <Typography variant="body2" sx={{ color: "#4fa94d", mb: 0.5 }}>
                            Current: {currentBadge}
                        </Typography>
                        <LinearProgress
                            variant="determinate"
                            value={progress}
                            sx={{
                                height: "6px",
                                borderRadius: "3px",
                                backgroundColor: "rgba(59, 63, 81, 1)",
                                "& .MuiLinearProgress-bar": {
                                    backgroundColor: "#4fa94d",
                                },
                            }}
                        />
                        <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.5)", display: "block", mt: 0.5 }}>
                            {leadsNeeded > 0
                                ? `${leadsNeeded} to next badge`
                                : "Highest badge achieved!"}
                        </Typography>
                    </Box>
                </Box>

                {/* Compact Badges List */}
                <Box sx={{ flex: 1, width: "100%", overflow: "auto", pb: 2 }}>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            color: "#ffffff",
                            px: 2,
                            py: 1,
                            fontWeight: "600",
                            position: "sticky",
                            top: 0,
                            background: "rgba(13, 18, 41, 0.9)",
                            zIndex: 1,
                        }}
                    >
                        Available Badges
                    </Typography>
                    <List sx={{ p: 0 }}>
                        {badgeBoardList?.map((badge) => (
                            <ListItem
                                key={badge.id}
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderBottom: "1px solid rgba(59, 63, 81, 0.5)",
                                    background: badge.id === userBadgeData?.badge?.id ? "rgba(79, 169, 77, 0.1)" : "transparent",
                                }}
                            >
                                <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                                    <Box sx={{ mr: 2, fontSize: "24px" }}>{badge.badge}</Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="subtitle2" sx={{ color: "#fff" }}>
                                            {badge.title}
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)" }}>
                                            {badge.lead_count} leads required
                                        </Typography>
                                    </Box>
                                    {badge.id === userBadgeData?.badge?.id && (
                                        <Box sx={{ color: "#4fa94d", fontSize: "12px", fontWeight: "bold" }}>
                                            CURRENT
                                        </Box>
                                    )}
                                </Box>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Box>
        </Fragment>
    );
};

export default BadgeBoard;